import { Card } from "../ui/card";
import { Phone, MessageCircle, Mail } from "lucide-react";

export const QuoteSidebar = () => (
  <div className="lg:col-span-1 space-y-6">
    {/* Prefer to Talk? */}
    <Card className="bg-white border border-border rounded-sm p-6">
      <h3 className="font-heading text-lg font-bold uppercase text-brand-navy mb-4">
        Prefer to Talk?
      </h3>
      <p className="text-sm text-brand-slate mb-6">
        Skip the form and reach out directly through your preferred channel.
      </p>

      <div className="space-y-4">
        <a
          href="tel:+14079494656"
          className="flex items-center gap-4 p-4 bg-brand-ice rounded-sm hover:bg-brand-navy hover:text-white group transition-colors"
        >
          <div className="w-12 h-12 bg-brand-navy rounded-sm flex items-center justify-center group-hover:bg-brand-orange transition-colors">
            <Phone className="w-6 h-6 text-brand-orange group-hover:text-white" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-brand-slate group-hover:text-white/70">Call Us</div>
            <div className="font-heading font-bold text-brand-navy group-hover:text-white">(407) 949-4656</div>
          </div>
        </a>

        <a
          href="https://wa.me/14079494656?text=Hello!%20I'm%20interested%20in%20your%20painting%20services."
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-4 p-4 bg-brand-ice rounded-sm hover:bg-green-600 hover:text-white group transition-colors"
        >
          <div className="w-12 h-12 bg-green-600 rounded-sm flex items-center justify-center">
            <MessageCircle className="w-6 h-6 text-white" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-brand-slate group-hover:text-white/70">WhatsApp</div>
            <div className="font-heading font-bold text-brand-navy group-hover:text-white">Chat With Us</div>
          </div>
        </a>

        <a
          href="mailto:sales@rollorlando.com?subject=Quote%20Request"
          className="flex items-center gap-4 p-4 bg-brand-ice rounded-sm hover:bg-brand-orange group transition-colors"
        >
          <div className="w-12 h-12 bg-brand-orange rounded-sm flex items-center justify-center group-hover:bg-brand-navy transition-colors">
            <Mail className="w-6 h-6 text-white group-hover:text-brand-orange" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-brand-slate group-hover:text-brand-navy/70">Email Us</div>
            <div className="font-heading font-bold text-brand-navy">sales@rollorlando.com</div>
          </div>
        </a>
      </div>
    </Card>

    {/* Office Hours */}
    <Card className="bg-brand-navy text-white rounded-sm p-6">
      <h3 className="font-heading text-lg font-bold uppercase mb-4">Office Hours</h3>
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-white/70">Monday - Friday</span>
          <span className="font-medium">7:00 AM - 6:00 PM</span>
        </div>
        <div className="flex justify-between">
          <span className="text-white/70">Saturday</span>
          <span className="font-medium">8:00 AM - 2:00 PM</span>
        </div>
        <div className="flex justify-between">
          <span className="text-white/70">Sunday</span>
          <span className="font-medium">Closed</span>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-white/20">
        <p className="text-xs text-white/60">
          Free estimates available - Call anytime during business hours
        </p>
      </div>
    </Card>

    {/* Quick Stats */}
    <Card className="bg-white border border-border rounded-sm p-6">
      <div className="grid grid-cols-2 gap-4 text-center">
        <div>
          <div className="font-heading text-3xl font-black text-brand-orange">24hr</div>
          <div className="text-xs text-brand-slate uppercase">Response Time</div>
        </div>
        <div>
          <div className="font-heading text-3xl font-black text-brand-orange">Free</div>
          <div className="text-xs text-brand-slate uppercase">Estimates</div>
        </div>
      </div>
    </Card>
  </div>
);
